module.exports = __webpack_public_path__ + "static/10_PLATOS-IRAN-ABGUSHT-D.e6dce443.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/10_PLATOS-IRAN-ABGUSHT-D.png
// module id = 653
// module chunks = 35783957827783